import { Alert, useMediaQuery, useTheme } from '@mui/material'
import { CardCollapse } from 'src/pages/sistema/components'
import { useFirmas } from '../hooks/useFirmas';
import { FirmasConLabels } from '../types/firma';
import CircularProgress from '@mui/material/CircularProgress'
import { FirmasMobile } from './mobile/FirmasMobile';
import { FirmasDesktop } from './desktop/FirmasDesktop';
import {SistemaTipo} from "../../../types/enum/enum";

interface SeccionFirmasProps {
    idOperacion: number
    codSistema: SistemaTipo
    /** Se ejecuta antes de aprobar/rechazar una firma. Si resuelve false, se cancela la acción. */
    beforeAccion?: () => Promise<boolean>
}

export const SeccionFirmas = ({ idOperacion, codSistema, beforeAccion }: SeccionFirmasProps) => {

    const { firmas, refetch, status } = useFirmas(codSistema, idOperacion);

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <CardCollapse title='Firmas' colapsable>
            {
                status === 'loading' && <CircularProgress disableShrink sx={{ mt: 6 }} />
            }
            {
                status === 'error' && <Alert severity='error'>Se produjo un error al cargar las firmas.</Alert>
            }
            {
                (status === 'success' && !firmas.firmas.length) &&
                <Alert severity='info'>No se encontraron firmas para esta operación.</Alert>
            }
            {
                (status === 'success' && !!firmas.firmas.length) && (
                    isSmallScreen ?
                        <FirmasMobile firmas={firmas} idOperacion={idOperacion} codSistema={codSistema} refetch={refetch} beforeAccion={beforeAccion} /> :
                        <FirmasDesktop firmas={firmas} idOperacion={idOperacion} codSistema={codSistema} refetch={refetch} beforeAccion={beforeAccion} />
                )
            }
        </CardCollapse>
    )
}

export type FirmasProps = {
    firmas: FirmasConLabels,
    idOperacion: number,
    codSistema: SistemaTipo,
    refetch: () => void,
    /** Se ejecuta antes de aprobar/rechazar una firma. Si resuelve false, se cancela la acción. */
    beforeAccion?: () => Promise<boolean>
}
